import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {ObjectClass, StorageUnitAllowableObjectClass} from '|api/commons';
import {CaseFileAllowableObjectClass, FileAllowableObjectClass} from '|api/document';
import {DocumentAllowableObjectClass} from '|api/sad';
import {CardComponent, IconComponent} from '@icz/angular-essentials';
import {ObjectClassIconComponent} from '|shared';
import {TranslatePipe} from '@ngx-translate/core';


@Component({
  selector: 'icz-object-association-alert',
  templateUrl: './object-association-alert.component.html',
  styleUrls: ['./object-association-alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CardComponent, ObjectClassIconComponent, IconComponent, TranslatePipe]
})
export class ObjectAssociationAlertComponent {

  @Input({required: true})
  heading!: string;
  @Input({required: true})
  associatedObjectClass!: ObjectClass | DocumentAllowableObjectClass | FileAllowableObjectClass | StorageUnitAllowableObjectClass | CaseFileAllowableObjectClass;
  @Input()
  isContentExpandable = false;

  protected isContentExpanded = false;

  protected toggleExpansionState(): void {
    if (this.isContentExpandable) {
      this.isContentExpanded = !this.isContentExpanded;
    }
  }

}
